const digest = '6f440da0cda804cf2ff2c6bf2aff26420274c7899a829d4ad849e6b2655e8688';
const css = `._passkey-assertion__loading_o7tn5_1{margin:1rem 0;text-align:center;width:100%}._passkey-assertion__verifying-title_o7tn5_7{color:#000;font-size:1.5rem;font-weight:600;margin:0 0 .75rem}._passkey-assertion__verifying-message_o7tn5_14{color:#53565a;font-size:1.125rem;line-height:1.5;margin:0 0 1.25rem}._passkey-assertion__verifying-status_o7tn5_21{color:#53565a;font-size:1rem;margin:.75rem 0 0}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'passkey-assertion__loading': '_passkey-assertion__loading_o7tn5_1', 'passkey-assertion__verifying-title': '_passkey-assertion__verifying-title_o7tn5_7', 'passkey-assertion__verifying-message': '_passkey-assertion__verifying-message_o7tn5_14', 'passkey-assertion__verifying-status': '_passkey-assertion__verifying-status_o7tn5_21' };

export { css, digest };